

















import { Component, Prop } from 'vue-property-decorator';
import CourseCardBase from '@/components/atoms/CourseCardBase.vue';
import CourseCardElearning from '@/components/organisms/CourseCardELearning.vue';
import CourseCardWebinar from '@/components/organisms/CourseCardWebinar.vue';
import CourseCardClassroom from '@/components/organisms/CourseCardClassroom.vue';
import ProgressBar from '@/components/atoms/ProgressBar.vue';
import Chip from '@/components/atoms/Chip.vue';
import CourseType from '@/components/atoms/CourseType.vue';
import CourseStatus from '@/components/atoms/CourseStatus.vue';
import {
  DoceboCatalogueViewLearningPlan,
  DoceboEnrolmentItemLearningPlan,
} from '@/lib/DoceboAPI';
import { HealthForceGoSkill } from '@/lib/HealthForceGoAPI';

@Component({
  components: {
    CourseCardElearning,
    CourseCardWebinar,
    CourseCardClassroom,
    ProgressBar,
    Chip,
    CourseType,
    CourseStatus,
  },
})
export default class CourseCardLearningPlan extends CourseCardBase {
  @Prop({
    default: {},
  })
  learningPlan!: DoceboCatalogueViewLearningPlan;

  @Prop() enrolment!: DoceboEnrolmentItemLearningPlan;

  private get learningPlanSkills(): HealthForceGoSkill[] {
    return this.$store.getters['skills/getSkillsForLearningPlan'](
      this.learningPlan.item_id
    );
  }

  private get progress(): number {
    if (this.enrolment) {
      return Math.round(
        this.enrolment.courses_count * (this.enrolment.complete_percent / 100)
      );
    }
    return 0;
  }

  private get total(): number {
    if (this.enrolment) {
      return this.enrolment.courses_count;
    }
    return 0;
  }

  private get chipText(): string {
    if (this.enrolment) {
      return `${this.progress}/${this.total}`;
    }
    return 'N/A';
  }
}
